import { useEffect, useState } from "react";
import styles from "./styles/SliderToggle.module.css";
const SliderToggle = ({
    inputId,
    inputValue,
    RadioOption,
    type,
    onClickFunction,
    data,
    leftLabel,
    rightLabel,
    small,
    disable,
}) => {
    const [currentValue, setCurrentValue] = useState("");
    useEffect(() => {
        setCurrentValue(inputValue);
    }, [inputValue]);
    return (
        <div className={`${styles.switch_container} flex-container`}>
            {leftLabel ? (
                <span className={`${styles.switch_label}`}>{leftLabel}</span>
            ) : (
                <></>
            )}
            <label
                className={`${styles.switch} ${
                    small ? styles.small_switch : ""
                } ${leftLabel ? styles.left_switch_margin : ""} ${
                    rightLabel ? styles.right_switch_margin : ""
                }${type === "radio" ? styles.switch2 : ""} `}
            >
                <input
                    disabled={disable}
                    type={type ? type : "checkbox"}
                    data-ex={data && data}
                    value={type === "radio" ? RadioOption : currentValue}
                    name={inputId}
                    checked={
                        type === "radio"
                            ? parseInt(currentValue) === RadioOption
                            : currentValue
                    }
                    onChange={onClickFunction}
                />
                <span
                    className={`${styles.slider} ${
                        small ? styles.small_slider : ""
                    } ${type === "radio" ? styles.slider2 : ""} ${
                        styles.round
                    }`}
                ></span>
            </label>
            {rightLabel ? (
                <span className={`${styles.switch_label}`}>{rightLabel}</span>
            ) : (
                <></>
            )}
        </div>
    );
};

export default SliderToggle;
